import ButtonDirective from './button.directive'

const ButtonModule = angular.module('cdbl.button', [

])
  .directive('cdblButton', ButtonDirective)
  .name

export default ButtonModule
